import { render, staticRenderFns } from "./BibliographyDetails.vue?vue&type=template&id=704adb45&"
import script from "./BibliographyDetails.vue?vue&type=script&lang=js&"
export * from "./BibliographyDetails.vue?vue&type=script&lang=js&"
import style0 from "./BibliographyDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports